"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var SplitProvider_1 = require("./SplitProvider");
/**
 * Returns a treatment and it's config.
 * @param {string} splitName - The string that represents the split we want to get the treatment.
 * @param {Attributes=} attributes - An object of type Attributes defining the attributes for the given key.
 * @returns {[string, string | null]} Tuple with treatment first and config second.
 */
exports.useSplit = function (splitName, attributes) {
    var _a = react_1.useContext(SplitProvider_1.SplitContext), client = _a.client, isReady = _a.isReady, lastUpdate = _a.lastUpdate;
    var _b = react_1.useState(SplitProvider_1.defaultTreatment), _c = _b[0], treatment = _c.treatment, config = _c.config, setTreatment = _b[1];
    react_1.useEffect(function () {
        var next = client && isReady
            ? client.getTreatmentWithConfig(splitName, attributes)
            : SplitProvider_1.defaultTreatment;
        setTreatment(next);
    }, [client, isReady, lastUpdate, splitName, attributes]);
    return [treatment, config];
};
//# sourceMappingURL=useSplit.js.map